import { Pipe, PipeTransform } from "@angular/core"
import { arrToCls } from "@app/helpers"

@Pipe({
	name: "clsArr",
})
export class ClsArrPipe implements PipeTransform {
	transform(arr: any[]) {
		return arrToCls(arr)
	}
}
